<template>
  <section :style="style" class="ugc-tray-wrapper-edit">
    <button
      type="button"
      class="button ugc-tray-wrapper-button ugc-tray-wrapper-edit-apply-button patternmaker-edit"
      @click="clicked"
      :disabled="disableButton"
    >
      &nbsp;
    </button>
    <div class="ugc-tray-wrapper-edit-container">
      <button
        type="button"
        class="ugc-tray-wrapper-edit-container-button"
        @click="edit"
      >
        <span class="icon icon-edit"></span>
        <span class="text">{{ translations.ugcEdit }}</span>
      </button>
    </div>
  </section>
</template>

<script>
import ugc from '@/mixins/UGC';
import undo from "@/mixins/Customizer/Undo";

const cloneDeep = require('lodash/cloneDeep');

export default {
  mixins: [ ugc, undo ],
  name: "CustomPatternEdit",
  props: {
    onClick: {
      type: Function,
      default: null
    },
    disableButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setDataLayer() {
      if (this.$store.getters['utils/useEcomDataLayerFormat']) {
        this.$customizerDataLayer.logAnalyticsEvent({ type: this.$customizerDataLayer.types.customizerCreateYourOwn, eventLabel: 'Pattern Maker' });
      }
    },
    trackData(eventAction = '', eventLabel = 'close modal click') {
      if (!this.$store.getters['utils/useEcomDataLayerFormat']) {
        dataLayer.push({
          event: "trackEvent",
          eventCategory: "customs",
          eventAction: `pattern-maker ${eventAction}`,
          eventLabel
        });
      }
    },
    clicked() {
      this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", "ugc");
      const { activeUGCComponent } = this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex];
      const feature = this.$recipe.getUGCFeatureType(activeUGCComponent);

      if (feature !== 'patternMaker') {
        this.$store.commit('swatches/SET_SWATCHES_SELECTED', {
          component: activeUGCComponent,
          data: { ...this.selectedSwatches[activeUGCComponent], default: false },
        });

        this.savePreviousSwatch({ feature });
      }

      if (this.$store.state.utils.configuration.enableFlyOutMenu) {
        const menu = cloneDeep(this.$store.state.standardNavigation.menu);

        const currentNode = menu.find(node => node.id === activeUGCComponent);

        if (currentNode) {
          currentNode.isChecked = !this.selectedSwatches[activeUGCComponent]?.default;
        }

        this.$store.commit('standardNavigation/UPDATE_MENU_STANDARD_NAVIGATION', { menu });
      }

      this.applyPatternMakerTo3D(activeUGCComponent);

      // tracks eventAction "Customizer - Create your own" / apply
      this.setDataLayer();

      // tracks eventAction "pattern maker"
      const secondaryComponent = this.secondaryComponent();
      const componentPosition = !secondaryComponent || !this.$ugc.isUGCCreatedByFeature(secondaryComponent, { includePatternMaker: true }) ? 'one' : 'second';
      const isSecondComponent = !secondaryComponent || !this.$ugc.isUGCCreatedByFeature(secondaryComponent, { includePatternMaker: true }) ? '' : ' - second component';
      this.trackData(isSecondComponent, "apply pattern from tray");
    },
    secondaryComponent() {
      const secondaryComponentName = this.$store.getters[
        "ugc/getUGCComponentNotActive"
      ];
      return this.$store.state.recipe.recipe_v2.components[secondaryComponentName];
    },
    edit() {
      // shows the pattern maker modal
      this.$modal.show("patternMaker");

      const { activeUGCComponent: activeUGCComponentName } = this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex];

      const activeUGCComponent = this.$store.state.recipe.recipe_v2.components[activeUGCComponentName];
      const secondaryComponent = this.secondaryComponent();
      const activeComponentHasPatternMaker = this.$ugc.isUGCCreatedByFeature(activeUGCComponent, { includePatternMaker: true });
      const secondaryComponentHasPatternMaker = this.$ugc.isUGCCreatedByFeature(secondaryComponent, { includePatternMaker: true });

      // tracks eventAction "Customizer - Create your own" / edit
      this.setDataLayer();

      // tracks eventAction "pattern maker"
      if (secondaryComponent && !activeComponentHasPatternMaker && secondaryComponentHasPatternMaker) {
        // the current component is the second component and it doesn't have pattern applied
        this.trackData('- second component', "apply pattern from tray");
      } else if (secondaryComponent && secondaryComponentHasPatternMaker) {
        // the current component is the second component and it already has pattern applied
        this.trackData('- second component', "edit");
      } else {
        // the current component is not the second component
        this.trackData('', "edit");
      }
    }
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    activeUGCComponent() {
      return this.$store.state.legacyNavigation.activeComponent;
    },
    nextComponent() {
      return this.$store.getters["ugc/getUGCComponentNotActive"];
    },
    style() {
      let bgImage = "";
      const { s3Url } = this.$store.state.endPoints.customizer;
      const { currentPattern } = this.$store.state.patternMaker;
      const checkForUGC =
        currentPattern[this.activeUGCComponent] ||
        (currentPattern[this.nextComponent] || "");

      if (checkForUGC) {
        const {
          original_image: { image_url }
        } = checkForUGC.ugc;
        bgImage = image_url.includes("http")
          ? image_url
          : `${s3Url}${image_url}`;
      }
      return {
        "background-image": `url(${bgImage})`
      };
    }
  }
};
</script>
